// components/widgets/primitives/possib-row.js
// ═══════════════════════════════════════════════════════════
// POSSIB ROW — sage-tinted inline row for possibilities,
// analogs, things-worth-noticing.
// ═══════════════════════════════════════════════════════════

import MetaField from './meta-field';

export default function PossibRow({ item = {}, className = '' }) {
  return (
    <div className={`ws-prim-possib ${className}`}>
      <div className="ws-prim-possib-observation">{item.observation}</div>
      {item.analog && <MetaField label="analog">{item.analog}</MetaField>}
      {Array.isArray(item.evidence) && item.evidence.length > 0 && (
        <MetaField label="evidence">{item.evidence.join(' · ')}</MetaField>
      )}
      {item.suggested_next_step && (
        <MetaField label="next">{item.suggested_next_step}</MetaField>
      )}
    </div>
  );
}
